import { Select, TextField, BlockStack } from '@shopify/polaris';
import { useState, useEffect, useCallback } from 'react';
import { apiGet } from '../api';

interface Segment {
  type: string;
  label: string;
  description: string;
}

interface SegmentPickerProps {
  value: { type: string; value?: string | number };
  onChange: (segment: { type: string; value?: string | number }) => void;
}

export default function SegmentPicker({ value, onChange }: SegmentPickerProps) {
  const [segments, setSegments] = useState<Segment[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    apiGet<{ segments: Segment[] }>('/panel-api/push/segments')
      .then((data) => setSegments(data.segments))
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  const handleTypeChange = useCallback(
    (type: string) => {
      onChange({ type, value: type === 'high_points' ? 500 : undefined });
    },
    [onChange],
  );

  const handleValueChange = useCallback(
    (val: string) => {
      onChange({ ...value, value: parseInt(val) || 0 });
    },
    [value, onChange],
  );

  const options = segments.map((s) => ({
    label: s.label,
    value: s.type,
  }));

  return (
    <BlockStack gap="200">
      <Select
        label="Target segment"
        options={[{ label: 'Select segment...', value: '' }, ...options]}
        value={value.type}
        onChange={handleTypeChange}
        disabled={loading}
      />
      {value.type === 'high_points' && (
        <TextField
          label="Minimum points"
          type="number"
          value={String(value.value ?? 500)}
          onChange={handleValueChange}
          autoComplete="off"
        />
      )}
    </BlockStack>
  );
}
